import { memo, useContext } from "react"
import styles from "./index.module.less";
import classNames from "classnames"
import { PlusOutlined } from "@ant-design/icons"
import { AddFlowSheetModal } from "./AddFlowSheetModal"
import { projectContext } from "@/layouts/MainLayout"
interface AddSheetCardProps {
  refresh: () => void
}
export const AddSheetCard = memo(({refresh}: AddSheetCardProps) => {
  const { projectId } = useContext(projectContext)
  return <div className={classNames(styles.container, 'flex-col-center')}>
    <div style={{width: '100%', cursor: 'pointer'}} onClick={() => AddFlowSheetModal.show({pId: projectId as string, onSuccess: () => {
      refresh()
    }})}>
      <div style={{textAlign: 'center', fontSize: 80, color: '#2C60EA'}}><PlusOutlined /></div>
      <div style={{textAlign: 'center', fontSize: 24, color: '#2C60EA'}} className="mt-1">New Flowsheet</div>
    </div>
  </div>
});